module.exports = __webpack_public_path__ + "static/media/cashCover@3x.3c975c4d.png";